/* ================================================================ */
// STYLED CONTAINER | StyledContainer.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React from 'react';
import useReactRouter from 'use-react-router';
import PropTypes from 'prop-types';
// Material UI
import makeStyles from '@material-ui/styles/makeStyles';
// Markdown
import Markdown from 'react-markdown';
import htmlParser from 'react-markdown/plugins/html-parser';
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        justifyContent: 'center',
        '& img': {
            objectFit: 'cover',
            width: '100%',
            height: '100%'
        }
    }
}));
/* ========================================== */
/**
 * Styled Container
 * ----------------
 * Outputs html/markdown content within a styled
 * div element
 *
 * @param {object} props component props
 * @param {string} content html content
 * @param {object} styles component styles
 */
const StyledContainer = ({styles, content}) => {
    const classes = useStyles();
    const parseHtml = htmlParser({
        isValidNode: node => node.type !== 'script',
        //processingInstructions: [/* ... */]
    });
    const renderParagraph = ({children}) => {
        if(children && children[0]
            && children.length === 1
            && children[0].props
            && children[0].props.src)
            return children;
        return <p>{children}</p>;
    };
    /* ======================== */
    // RENDER
    /* ======================== */
    return (
        <div className={classes.root} style={styles}>
            <Markdown
                renderers={{paragraph: renderParagraph}}
                source={content}
                escapeHtml={false}
                astPlugins={[parseHtml]}
            />
        </div>
    );
};
/* ======================== */
// PROPS
/* ======================== */
StyledContainer.propTypes = {
    styles: PropTypes.object,
    content: PropTypes.string
};
StyledContainer.defaultProps = {
    styles: {},
    content: ''
};
StyledContainer.displayName = 'StyledContainer';
/* ========================================== */
// Export
/* ========================================== */
export default StyledContainer;